import Http from "../http";
import { ReferralInfo, Membership, User } from "../models/foxone";

export default function(http: Http) {
  return {
    getReferralInfo(): Promise<ReferralInfo> {
      return http.get("/foxone/account/referral");
    },

    getMembership(): Promise<Membership> {
      return http.get("/foxone/membership");
    },

    putReferralCode(code: string) {
      return http.put("/foxone/account/referral", {
        data: { referral_code: code }
      });
    },

    getUserByReferralCode(code: string): Promise<User> {
      return http.get("/foxone/account/users", { params: { invite: code } });
    },

    claimReward(id: string) {
      return http.post(`/foxone/reward/${id}`);
    }
  };
}
